var exports = {
  "i": "x31de4314--2ae011--wrapper",
};

module.exports = exports;
